<template>
    <b-row>
        <b-col md="12">
            <gofix-card fullContent class="mb-0">
                <gofix-table
                    class="hoverUnderLineLink noFullHeight"
                    :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    @row-click="goToDetail"
                    ref="gofixTable">
                    <template slot="gofix_table:reference_number" slot-scope="row">
                        <span class="link">{{row.item.reference_number}}</span>
                    </template>
                    <template slot="gofix_table:issue_date" slot-scope="row">
                        {{row.item.issue_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                    </template>
                </gofix-table>
            </gofix-card>
        </b-col>
    </b-row>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'pv-related-work-item',
        components: {},
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['pv_related_work_item']));
            return {
                tableConfig:{
                    name: 'order_work_folder',
                    controls:{
                        tableImport: false,
                        create: false,
                        delete: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'reference_number',
                            label: 'Reference No',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'reference_value_text',
                            label: 'Type',
                            thStyle: "width:auto",
                            width: null,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'issue_date',
                            label: 'Date Issued',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'person_in_charge',
                            label: 'PIC',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'supplier',
                            label: 'Supplier',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:200px",
                            width: 200,
                            sorting: true
                        },
                        {
                            key: 'item_status',
                            label: 'Status',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            width: 150,
                            sorting: true
                        },
                    ]
                },
                tableItems:[],
            }
        },
        watch: {
            "OrderItem": function (val) {
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        computed: {
            ...mapGetters({
                pvItem: "PaymentVoucherController/Item",
            })
        },
        created() {},
        methods:{
            /*---------- Table event ----------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(!this.pvItem.folder_id){
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    resolve({
                        items:[],
                        total:0
                    });
                    return;
                }
                tableRequest.filter.folder_id.value = this.pvItem.folder_id;
                await this.$store.dispatch("WorkFolderController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load items", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    });
            },
            goToDetail(item){
                let routeData = null;
                switch (item.reference_value_text) {
                    case "Work order":
                        routeData = this.$router.resolve(`/v2/orders/${item.work_item_id}`);
                        break;
                    case "AP Invoice":
                        routeData = this.$router.resolve(`/v2/ap-invoice/${item.work_item_id}`);
                        break;
                    case "Payment voucher":
                        routeData = this.$router.resolve(`/v2/payment-voucher/${item.work_item_id}`);
                        break;
                    case "Misc Expense":
                        routeData = this.$router.resolve(`/v2/misc-expenses/${item.work_item_id}`);
                        break;
                    case "Issue Register":
                        routeData = this.$router.resolve(`/v2/issue-register/${item.work_item_id}`);
                        break;    
                    default:
                        routeData = this.$router.resolve(`/v2/case/${item.work_item_id}`);
                        break;
                }
                if(routeData){
                    window.open(routeData.href, '_blank');
                }
            }
            /*----------------------------------------*/
        }
    }
</script>
